(function () {
if (customElements.get('featured-collection-dots')) return;
class FeaturedCollectionDots extends HTMLElement {
    connectedCallback() {
        if (this.onSlideChanged) return;
        this.sliderComponent = this.closest('slider-component');
        if (!this.sliderComponent?.slider) return;
        this.onSlideChanged = (event) => this.render(event.detail.currentPage);
        this.sliderComponent.addEventListener('slideChanged', this.onSlideChanged);
        this.resizeObserver = new ResizeObserver(() => this.scheduleRender(true));
        this.resizeObserver.observe(this.sliderComponent.slider);
        this.scheduleRender(true);
    }

    disconnectedCallback() {
        this.sliderComponent?.removeEventListener('slideChanged', this.onSlideChanged);
        this.resizeObserver?.disconnect();
        this.onSlideChanged = null;
    }

    scheduleRender(rebuild = false) {
        window.requestAnimationFrame(() => this.render(this.sliderComponent.currentPage || 1, rebuild));
    }

    render(currentPage = 1, rebuild = false) {
        const totalPages = Math.max(1, this.sliderComponent.totalPages || 1);
        this.hidden = totalPages <= 1;
        if (Number(this.dataset.totalPages) !== totalPages) {
            this.dataset.totalPages = String(totalPages);
            this.replaceChildren(...Array.from({ length: totalPages }, (_, index) => {
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'wp-slider-dot';
                button.setAttribute('aria-label', `Go to slide ${index + 1} of ${totalPages}`);
                button.addEventListener('click', () => this.goToPage(index + 1));
                return button;
            }));
        }
        Array.from(this.children).forEach((dot, index) => {
            const active = index + 1 === currentPage;
            dot.classList.toggle('is-active', active);
            active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current');
        });
    }

    goToPage(page) {
        this.sliderComponent.setSlidePosition((page - 1) * this.sliderComponent.sliderItemOffset);
    }
}

if (!customElements.get('featured-collection-dots')) {
    customElements.define('featured-collection-dots', FeaturedCollectionDots);
}
})();
